<script setup lang='ts'>
import zhCn from 'element-plus/es/locale/lang/zh-cn'

const size = 'large'

useProfileStore().setScope(PermissionScope.cinema)
</script>

<template>
  <el-config-provider :locale="zhCn" :size :button="{ autoInsertSpace: true }">
    <RouterView />
  </el-config-provider>
</template>

<style lang='scss'>
</style>
